<!-- Breadcrumb Area -->
<div class="breadcrumb-area">
    <h1>Dashboard</h1>

    <ol class="breadcrumb">
        <li class="item"><a routerLink="/icons/feathericons"><i class='bx bx-home-alt'></i></a></li>

        <li class="item">Dashboard</li>

        <li class="item">Feather Icons</li>
    </ol>
</div>
<!-- End Breadcrumb Area -->

<!-- Start Feather Icon -->
<div class="feather-icons-list">
    <div class="feather-icons-box mb-30">
        <div class="demo-code-preview mt-2" data-label="Code Example">
            <div class="highlight" id="iconsFeatherBasicExample"><pre><code class="language-html" data-lang="html"><span class="nt">&lt;i</span> <span class="na">data-feather=</span><span class="s">"circle"</span><span class="nt">&gt;</span><span class="nt">&lt;/i&gt;</span></code></pre>

                <button type="button" class="btn btn-clipboard" data-clipboard-target="#iconsFeatherBasicExample"><i class='bx bx-copy'></i></button>
            </div>
        </div>
    </div>

    <div class="row align-items-center">
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="activity"></i></div>
                <div class="icon-box-name">activity</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="airplay"></i></div>
                <div class="icon-box-name">airplay</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="alert-circle"></i></div>
                <div class="icon-box-name">alert-circle</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="alert-octagon"></i></div>
                <div class="icon-box-name">alert-octagon</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="alert-triangle"></i></div>
                <div class="icon-box-name">alert-triangle</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="align-center"></i></div>
                <div class="icon-box-name">align-center</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="align-justify"></i></div>
                <div class="icon-box-name">align-justify</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="align-left"></i></div>
                <div class="icon-box-name">align-left</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="align-right"></i></div>
                <div class="icon-box-name">align-right</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="anchor"></i></div>
                <div class="icon-box-name">anchor</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="aperture"></i></div>
                <div class="icon-box-name">aperture</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="archive"></i></div>
                <div class="icon-box-name">archive</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="arrow-down"></i></div>
                <div class="icon-box-name">arrow-down</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="arrow-down-circle"></i></div>
                <div class="icon-box-name">arrow-down-circle</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="arrow-down-left"></i></div>
                <div class="icon-box-name">arrow-down-left</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="arrow-down-right"></i></div>
                <div class="icon-box-name">arrow-down-right</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="arrow-left"></i></div>
                <div class="icon-box-name">arrow-left</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="arrow-left-circle"></i></div>
                <div class="icon-box-name">arrow-left-circle</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="arrow-right"></i></div>
                <div class="icon-box-name">arrow-right</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="arrow-right-circle"></i></div>
                <div class="icon-box-name">arrow-right-circle</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="arrow-up"></i></div>
                <div class="icon-box-name">arrow-up</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="arrow-up-circle"></i></div>
                <div class="icon-box-name">arrow-up-circle</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="arrow-up-left"></i></div>
                <div class="icon-box-name">arrow-up-left</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="arrow-up-right"></i></div>
                <div class="icon-box-name">arrow-up-right</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="at-sign"></i></div>
                <div class="icon-box-name">at-sign</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="award"></i></div>
                <div class="icon-box-name">award</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="bar-chart"></i></div>
                <div class="icon-box-name">bar-chart</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="bar-chart-2"></i></div>
                <div class="icon-box-name">bar-chart-2</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="battery"></i></div>
                <div class="icon-box-name">battery</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="battery-charging"></i></div>
                <div class="icon-box-name">battery-charging</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="bell"></i></div>
                <div class="icon-box-name">bell</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="bell-off"></i></div>
                <div class="icon-box-name">bell-off</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="bluetooth"></i></div>
                <div class="icon-box-name">bluetooth</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="bold"></i></div>
                <div class="icon-box-name">bold</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="book"></i></div>
                <div class="icon-box-name">book</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="bookmark"></i></div>
                <div class="icon-box-name">bookmark</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="book-open"></i></div>
                <div class="icon-box-name">book-open</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="box"></i></div>
                <div class="icon-box-name">box</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="briefcase"></i></div>
                <div class="icon-box-name">briefcase</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="calendar"></i></div>
                <div class="icon-box-name">calendar</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="camera"></i></div>
                <div class="icon-box-name">camera</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="camera-off"></i></div>
                <div class="icon-box-name">camera-off</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="cast"></i></div>
                <div class="icon-box-name">cast</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="check"></i></div>
                <div class="icon-box-name">check</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="check-circle"></i></div>
                <div class="icon-box-name">check-circle</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="check-square"></i></div>
                <div class="icon-box-name">check-square</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="chevron-down"></i></div>
                <div class="icon-box-name">chevron-down</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="chevron-left"></i></div>
                <div class="icon-box-name">chevron-left</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="chevron-right"></i></div>
                <div class="icon-box-name">chevron-right</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="chevrons-down"></i></div>
                <div class="icon-box-name">chevrons-down</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="chevrons-left"></i></div>
                <div class="icon-box-name">chevrons-left</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="chevrons-right"></i></div>
                <div class="icon-box-name">chevrons-right</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="chevrons-up"></i></div>
                <div class="icon-box-name">chevrons-up</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="chevron-up"></i></div>
                <div class="icon-box-name">chevron-up</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="chrome"></i></div>
                <div class="icon-box-name">chrome</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="circle"></i></div>
                <div class="icon-box-name">circle</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="clipboard"></i></div>
                <div class="icon-box-name">clipboard</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="clock"></i></div>
                <div class="icon-box-name">clock</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="cloud"></i></div>
                <div class="icon-box-name">cloud</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="cloud-drizzle"></i></div>
                <div class="icon-box-name">cloud-drizzle</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="cloud-lightning"></i></div>
                <div class="icon-box-name">cloud-lightning</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="cloud-off"></i></div>
                <div class="icon-box-name">cloud-off</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="cloud-rain"></i></div>
                <div class="icon-box-name">cloud-rain</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="cloud-snow"></i></div>
                <div class="icon-box-name">cloud-snow</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="code"></i></div>
                <div class="icon-box-name">code</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="codepen"></i></div>
                <div class="icon-box-name">codepen</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="codesandbox"></i></div>
                <div class="icon-box-name">codesandbox</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="coffee"></i></div>
                <div class="icon-box-name">coffee</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="columns"></i></div>
                <div class="icon-box-name">columns</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="command"></i></div>
                <div class="icon-box-name">command</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="compass"></i></div>
                <div class="icon-box-name">compass</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="copy"></i></div>
                <div class="icon-box-name">copy</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="corner-down-left"></i></div>
                <div class="icon-box-name">corner-down-left</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="corner-down-right"></i></div>
                <div class="icon-box-name">corner-down-right</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="corner-left-down"></i></div>
                <div class="icon-box-name">corner-left-down</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="corner-left-up"></i></div>
                <div class="icon-box-name">corner-left-up</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="corner-right-down"></i></div>
                <div class="icon-box-name">corner-right-down</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="corner-right-up"></i></div>
                <div class="icon-box-name">corner-right-up</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="corner-up-left"></i></div>
                <div class="icon-box-name">corner-up-left</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="corner-up-right"></i></div>
                <div class="icon-box-name">corner-up-right</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="cpu"></i></div>
                <div class="icon-box-name">cpu</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="credit-card"></i></div>
                <div class="icon-box-name">credit-card</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="crop"></i></div>
                <div class="icon-box-name">crop</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="crosshair"></i></div>
                <div class="icon-box-name">crosshair</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="database"></i></div>
                <div class="icon-box-name">database</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="delete"></i></div>
                <div class="icon-box-name">delete</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="disc"></i></div>
                <div class="icon-box-name">disc</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="dollar-sign"></i></div>
                <div class="icon-box-name">dollar-sign</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="download"></i></div>
                <div class="icon-box-name">download</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="download-cloud"></i></div>
                <div class="icon-box-name">download-cloud</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="droplet"></i></div>
                <div class="icon-box-name">droplet</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="edit"></i></div>
                <div class="icon-box-name">edit</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="edit-2"></i></div>
                <div class="icon-box-name">edit-2</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="edit-3"></i></div>
                <div class="icon-box-name">edit-3</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="external-link"></i></div>
                <div class="icon-box-name">external-link</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="eye"></i></div>
                <div class="icon-box-name">eye</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="eye-off"></i></div>
                <div class="icon-box-name">eye-off</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="facebook"></i></div>
                <div class="icon-box-name">facebook</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="fast-forward"></i></div>
                <div class="icon-box-name">fast-forward</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="feather"></i></div>
                <div class="icon-box-name">feather</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="figma"></i></div>
                <div class="icon-box-name">figma</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="file"></i></div>
                <div class="icon-box-name">file</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="file-minus"></i></div>
                <div class="icon-box-name">file-minus</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="file-plus"></i></div>
                <div class="icon-box-name">file-plus</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="file-text"></i></div>
                <div class="icon-box-name">file-text</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="film"></i></div>
                <div class="icon-box-name">film</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="filter"></i></div>
                <div class="icon-box-name">filter</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="flag"></i></div>
                <div class="icon-box-name">flag</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="folder"></i></div>
                <div class="icon-box-name">folder</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="folder-minus"></i></div>
                <div class="icon-box-name">folder-minus</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="folder-plus"></i></div>
                <div class="icon-box-name">folder-plus</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="framer"></i></div>
                <div class="icon-box-name">framer</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="frown"></i></div>
                <div class="icon-box-name">frown</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="gift"></i></div>
                <div class="icon-box-name">gift</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="git-branch"></i></div>
                <div class="icon-box-name">git-branch</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="git-commit"></i></div>
                <div class="icon-box-name">git-commit</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="github"></i></div>
                <div class="icon-box-name">github</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="gitlab"></i></div>
                <div class="icon-box-name">gitlab</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="git-merge"></i></div>
                <div class="icon-box-name">git-merge</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="git-pull-request"></i></div>
                <div class="icon-box-name">git-pull-request</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="globe"></i></div>
                <div class="icon-box-name">globe</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="grid"></i></div>
                <div class="icon-box-name">grid</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="hard-drive"></i></div>
                <div class="icon-box-name">hard-drive</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="hash"></i></div>
                <div class="icon-box-name">hash</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="headphones"></i></div>
                <div class="icon-box-name">headphones</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="heart"></i></div>
                <div class="icon-box-name">heart</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="help-circle"></i></div>
                <div class="icon-box-name">help-circle</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="hexagon"></i></div>
                <div class="icon-box-name">hexagon</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="home"></i></div>
                <div class="icon-box-name">home</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="image"></i></div>
                <div class="icon-box-name">image</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="inbox"></i></div>
                <div class="icon-box-name">inbox</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="info"></i></div>
                <div class="icon-box-name">info</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="instagram"></i></div>
                <div class="icon-box-name">instagram</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="italic"></i></div>
                <div class="icon-box-name">italic</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="key"></i></div>
                <div class="icon-box-name">key</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="layers"></i></div>
                <div class="icon-box-name">layers</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="layout"></i></div>
                <div class="icon-box-name">layout</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="life-buoy"></i></div>
                <div class="icon-box-name">life-buoy</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="link"></i></div>
                <div class="icon-box-name">link</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="link-2"></i></div>
                <div class="icon-box-name">link-2</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="linkedin"></i></div>
                <div class="icon-box-name">linkedin</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="list"></i></div>
                <div class="icon-box-name">list</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="loader"></i></div>
                <div class="icon-box-name">loader</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="lock"></i></div>
                <div class="icon-box-name">lock</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="log-in"></i></div>
                <div class="icon-box-name">log-in</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="log-out"></i></div>
                <div class="icon-box-name">log-out</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="mail"></i></div>
                <div class="icon-box-name">mail</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="map"></i></div>
                <div class="icon-box-name">map</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="map-pin"></i></div>
                <div class="icon-box-name">map-pin</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="maximize"></i></div>
                <div class="icon-box-name">maximize</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="maximize-2"></i></div>
                <div class="icon-box-name">maximize-2</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="meh"></i></div>
                <div class="icon-box-name">meh</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="menu"></i></div>
                <div class="icon-box-name">menu</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="message-circle"></i></div>
                <div class="icon-box-name">message-circle</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="message-square"></i></div>
                <div class="icon-box-name">message-square</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="mic"></i></div>
                <div class="icon-box-name">mic</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="mic-off"></i></div>
                <div class="icon-box-name">mic-off</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="minimize"></i></div>
                <div class="icon-box-name">minimize</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="minimize-2"></i></div>
                <div class="icon-box-name">minimize-2</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="minus"></i></div>
                <div class="icon-box-name">minus</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="minus-circle"></i></div>
                <div class="icon-box-name">minus-circle</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="minus-square"></i></div>
                <div class="icon-box-name">minus-square</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="monitor"></i></div>
                <div class="icon-box-name">monitor</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="moon"></i></div>
                <div class="icon-box-name">moon</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="more-horizontal"></i></div>
                <div class="icon-box-name">more-horizontal</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="more-vertical"></i></div>
                <div class="icon-box-name">more-vertical</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="mouse-pointer"></i></div>
                <div class="icon-box-name">mouse-pointer</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="move"></i></div>
                <div class="icon-box-name">move</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="music"></i></div>
                <div class="icon-box-name">music</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="navigation"></i></div>
                <div class="icon-box-name">navigation</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="navigation-2"></i></div>
                <div class="icon-box-name">navigation-2</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="octagon"></i></div>
                <div class="icon-box-name">octagon</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="package"></i></div>
                <div class="icon-box-name">package</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="paperclip"></i></div>
                <div class="icon-box-name">paperclip</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="pause"></i></div>
                <div class="icon-box-name">pause</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="pause-circle"></i></div>
                <div class="icon-box-name">pause-circle</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="pen-tool"></i></div>
                <div class="icon-box-name">pen-tool</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="percent"></i></div>
                <div class="icon-box-name">percent</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="phone"></i></div>
                <div class="icon-box-name">phone</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="phone-call"></i></div>
                <div class="icon-box-name">phone-call</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="phone-forwarded"></i></div>
                <div class="icon-box-name">phone-forwarded</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="phone-incoming"></i></div>
                <div class="icon-box-name">phone-incoming</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="phone-missed"></i></div>
                <div class="icon-box-name">phone-missed</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="phone-off"></i></div>
                <div class="icon-box-name">phone-off</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="phone-outgoing"></i></div>
                <div class="icon-box-name">phone-outgoing</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="pie-chart"></i></div>
                <div class="icon-box-name">pie-chart</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="play"></i></div>
                <div class="icon-box-name">play</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="play-circle"></i></div>
                <div class="icon-box-name">play-circle</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="plus"></i></div>
                <div class="icon-box-name">plus</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="plus-circle"></i></div>
                <div class="icon-box-name">plus-circle</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="plus-square"></i></div>
                <div class="icon-box-name">plus-square</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="pocket"></i></div>
                <div class="icon-box-name">pocket</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="power"></i></div>
                <div class="icon-box-name">power</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="printer"></i></div>
                <div class="icon-box-name">printer</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="radio"></i></div>
                <div class="icon-box-name">radio</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="refresh-ccw"></i></div>
                <div class="icon-box-name">refresh-ccw</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="refresh-cw"></i></div>
                <div class="icon-box-name">refresh-cw</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="rss"></i></div>
                <div class="icon-box-name">rss</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="save"></i></div>
                <div class="icon-box-name">save</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="scissors"></i></div>
                <div class="icon-box-name">scissors</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="search"></i></div>
                <div class="icon-box-name">search</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="save"></i></div>
                <div class="icon-box-name">save</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="server"></i></div>
                <div class="icon-box-name">server</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="settings"></i></div>
                <div class="icon-box-name">settings</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="share"></i></div>
                <div class="icon-box-name">share</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="share-2"></i></div>
                <div class="icon-box-name">share-2</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="shield"></i></div>
                <div class="icon-box-name">shield</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="shield-off"></i></div>
                <div class="icon-box-name">shield-off</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="shopping-bag"></i></div>
                <div class="icon-box-name">shopping-bag</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="shopping-cart"></i></div>
                <div class="icon-box-name">shopping-cart</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="shuffle"></i></div>
                <div class="icon-box-name">shuffle</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="sidebar"></i></div>
                <div class="icon-box-name">sidebar</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="skip-back"></i></div>
                <div class="icon-box-name">skip-back</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="skip-forward"></i></div>
                <div class="icon-box-name">skip-forward</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="slack"></i></div>
                <div class="icon-box-name">slack</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="slash"></i></div>
                <div class="icon-box-name">slash</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="sliders"></i></div>
                <div class="icon-box-name">sliders</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="smartphone"></i></div>
                <div class="icon-box-name">smartphone</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="smile"></i></div>
                <div class="icon-box-name">smile</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="speaker"></i></div>
                <div class="icon-box-name">speaker</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="square"></i></div>
                <div class="icon-box-name">square</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="star"></i></div>
                <div class="icon-box-name">star</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="stop-circle"></i></div>
                <div class="icon-box-name">stop-circle</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="sun"></i></div>
                <div class="icon-box-name">sun</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="sunrise"></i></div>
                <div class="icon-box-name">sunrise</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="sunset"></i></div>
                <div class="icon-box-name">sunset</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="tablet"></i></div>
                <div class="icon-box-name">tablet</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="tag"></i></div>
                <div class="icon-box-name">tag</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="target"></i></div>
                <div class="icon-box-name">target</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="terminal"></i></div>
                <div class="icon-box-name">terminal</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="thermometer"></i></div>
                <div class="icon-box-name">thermometer</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="thumbs-down"></i></div>
                <div class="icon-box-name">thumbs-down</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="thumbs-up"></i></div>
                <div class="icon-box-name">thumbs-up</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="toggle-left"></i></div>
                <div class="icon-box-name">toggle-left</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="toggle-right"></i></div>
                <div class="icon-box-name">toggle-right</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="tool"></i></div>
                <div class="icon-box-name">tool</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="trash"></i></div>
                <div class="icon-box-name">trash</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="trash-2"></i></div>
                <div class="icon-box-name">trash-2</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="trello"></i></div>
                <div class="icon-box-name">trello</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="trending-down"></i></div>
                <div class="icon-box-name">trending-down</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="trending-up"></i></div>
                <div class="icon-box-name">trending-up</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="triangle"></i></div>
                <div class="icon-box-name">triangle</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="truck"></i></div>
                <div class="icon-box-name">truck</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="tv"></i></div>
                <div class="icon-box-name">tv</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="twitch"></i></div>
                <div class="icon-box-name">twitch</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="twitter"></i></div>
                <div class="icon-box-name">twitter</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="type"></i></div>
                <div class="icon-box-name">type</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="umbrella"></i></div>
                <div class="icon-box-name">umbrella</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="underline"></i></div>
                <div class="icon-box-name">underline</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="unlock"></i></div>
                <div class="icon-box-name">unlock</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="upload"></i></div>
                <div class="icon-box-name">upload</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="upload-cloud"></i></div>
                <div class="icon-box-name">upload-cloud</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="user"></i></div>
                <div class="icon-box-name">user</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="user-check"></i></div>
                <div class="icon-box-name">user-check</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="user-minus"></i></div>
                <div class="icon-box-name">user-minus</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="user-plus"></i></div>
                <div class="icon-box-name">user-plus</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="users"></i></div>
                <div class="icon-box-name">users</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="user-x"></i></div>
                <div class="icon-box-name">user-x</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="video"></i></div>
                <div class="icon-box-name">video</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="video-off"></i></div>
                <div class="icon-box-name">video-off</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="voicemail"></i></div>
                <div class="icon-box-name">voicemail</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="volume"></i></div>
                <div class="icon-box-name">volume</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="volume-1"></i></div>
                <div class="icon-box-name">volume-1</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="volume-2"></i></div>
                <div class="icon-box-name">volume-2</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="volume-x"></i></div>
                <div class="icon-box-name">volume-x</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="watch"></i></div>
                <div class="icon-box-name">watch</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="wifi"></i></div>
                <div class="icon-box-name">wifi</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="wifi-off"></i></div>
                <div class="icon-box-name">wifi-off</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="wind"></i></div>
                <div class="icon-box-name">wind</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="x"></i></div>
                <div class="icon-box-name">x</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="x-circle"></i></div>
                <div class="icon-box-name">x-circle</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="x-octagon"></i></div>
                <div class="icon-box-name">x-octagon</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="x-square"></i></div>
                <div class="icon-box-name">x-square</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="youtube"></i></div>
                <div class="icon-box-name">youtube</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="zap"></i></div>
                <div class="icon-box-name">zap</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="zap-off"></i></div>
                <div class="icon-box-name">zap-off</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="zoom-in"></i></div>
                <div class="icon-box-name">zoom-in</div>
            </div>
        </div>
        <div class="icon-box">
            <div class="icon-box-inner">
                <div class="icon-base"><i data-feather="zoom-out"></i></div>
                <div class="icon-box-name">zoom-out</div>
            </div>
        </div>
    </div>
</div>
<!-- End Feather Icon -->